import { Reducer } from "redux";

import { HealthProgramResponse } from "../models/Api/Master";
import { HealthProgramDispatchTypes } from "../models/DispatchTypes/Master";
import { HealthProgramActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

export const initialState: HealthProgramResponse = {
  loading: false,
  response: [],
};

const HealthProgramReducer: Reducer<
  HealthProgramResponse,
  HealthProgramDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_SUCCESS: {
      setLocalStorageData(
        HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default HealthProgramReducer;
